import React from "react";
import RoleProgress from "../../progressBar/RoleProgress";
import { X } from "lucide-react";

const SetPermissions = ({
  id,
  closePermissionsModal,
  permissionsModalOpen,
  openPermissionsModal,
  openReviewPermissionsModal,
  openModal,
  roleName,
  setRoleName,
  roleDescription,
  setRoleDescription,
  modules,
  selectedPermissions,
  setSelectedPermissions,
}) => {
  const handleCheckboxChange = (permissionId) => {
    const isSelected = selectedPermissions.includes(permissionId);

    if (isSelected) {
      // If permission is already selected, remove it
      setSelectedPermissions((prevSelected) =>
        prevSelected.filter((id) => id !== permissionId)
      );
    } else {
      // If permission is not selected, add it
      setSelectedPermissions((prevSelected) => [...prevSelected, permissionId]);
    }
  };

  const handleNextButtonClick = () => {
    closePermissionsModal();
    openReviewPermissionsModal();
  };

  const handleBackButtonClick = () => {
    closePermissionsModal();
    openModal();
  };
  return (
    <div
      id={id}
      className={`${
        permissionsModalOpen ? "flex" : "hidden"
      } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
    >
      <div className="relative rounded-[10px] flex h-[600px] w-[1080px] bg-white shadow">
        <div
          onClick={closePermissionsModal}
          className="absolute top-[0px] cursor-pointer h-[40px] w-[40px] bg-[#FF0000] rounded-tr-[10px] rounded-bl-[20px] right-[0px] flex items-center justify-center"
        >
          <X color="#ffffff" />
        </div>
        <div className="flex-col flex w-full mx-auto">
          <div className="flex h-full">
            <div className="w-[28%] p-[20px] rounded-[10px] bg-[#F5F6F7]">
              <div className="rounded-t">
                <p className="text-[20px] font-bold text-[#000] mb-[15px]">
                  Create a new role
                </p>
              </div>
              <div>
                <RoleProgress step={2} />
              </div>
            </div>
            <div className="w-[72%] mx-[10px] flex flex-col mt-5 justify-between">
              <div className="h-[85%] w-[95%]">
                <div className="mx-auto items-center">
                  <p className="text-[#000] text-xl font-bold">
                    Set Permissions
                  </p>
                  <div className="text-[#000] mt-2 text-sm font-normal">
                    <p>
                      Set permissions for the role you have just entered to
                      ensure precise access control.
                    </p>
                  </div>
                </div>
                <div className="flex flex-col gap-2 justify-between mt-[20px]">
                  <p className="text-[#000] font-bold">Select Permissions</p>
                  <div className="h-[350px] w-[100%] border-[1px] border-[#000000] p-3 overflow-y-auto">
                    {modules &&
                      modules?.map((module) => (
                        <div key={module?.id}>
                          <p className="text-[#000] font-bold">
                            {module?.name}
                          </p>
                          {module?.permissions?.map((permission) => (
                            <div
                              className="w-full flex items-center mt-3"
                              key={permission?.id}
                            >
                              <div className="w-[75%] mb-3">
                                <p>{permission?.name}</p>
                              </div>
                              <div className="w-[25%] mb-3 flex items-center justify-end">
                                <input
                                  type="checkbox"
                                  className="custom-checkbox"
                                  checked={selectedPermissions?.includes(
                                    permission?.id
                                  )}
                                  onChange={() =>
                                    handleCheckboxChange(permission?.id)
                                  }
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      ))}
                  </div>
                </div>
              </div>
              <div className="flex h-[15%] w-[95%] items-center justify-between">
                <div className="flex items-center justify-between gap-[20px] w-[16vw]">
                  <button
                    onClick={handleBackButtonClick}
                    data-modal-toggle={id}
                    type="button"
                    className="text-[#000] bg-[#7FB8EB] hover:bg-[#7FB8EB] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
                  >
                    Back
                  </button>
                  <button
                    onClick={handleNextButtonClick}
                    data-modal-toggle={id}
                    type="button"
                    className="text-white bg-[#074073] hover:bg-[#074073] focus:outline-none font-medium rounded-[5px] text-sm px-8 py-2.5 text-center"
                  >
                    Next
                  </button>
                </div>
                <button
                  onClick={closePermissionsModal}
                  data-modal-toggle={id}
                  type="button"
                  className="text-gray-500 bg-[#D9D9D9] hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-[5px] border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SetPermissions;
